import React from 'react';

import { NodeViewWrapper } from '@tiptap/react';

import DataTypePill from '../../../DataTypePill/DataTypePill';
import { RichTextEditorCustomMentionPillWrapper } from './styled';

export const RichTextEditorCustomMentionPill = (props) => {
  const { title, 'data-type': type, 'data-slug': slug } = props.node.attrs;

  const typeMap = {
    'member-company': 'company',
    articles: 'article',
  };

  return (
    <NodeViewWrapper style={{ display: 'inline-block', width: 'fit-content', margin: '2px 0px' }}>
      <RichTextEditorCustomMentionPillWrapper>
        <DataTypePill
          type={typeMap[type] || type}
          title={title}
          slug={slug}
          clickable={false}
          shared={false}
          themeMode="high-contrast-light"
        />
      </RichTextEditorCustomMentionPillWrapper>
    </NodeViewWrapper>
  );
};
